import { render } from "./status_content.vue?vue&type=template&id=79c8e5d6"
import script from "./status_content.js?vue&type=script&lang=js"
export * from "./status_content.js?vue&type=script&lang=js"

import "./status_content.vue?vue&type=style&index=0&id=79c8e5d6&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__